import React from 'react';
import styled from 'styled-components';
import tw from 'twin.macro';
import Skeleton from '../Skeleton';

const Container = styled.div`
  ${tw`p-4 rounded-lg`}
`;

const CardNumberSection = styled.div`
  ${tw`mb-6`}
`;

const SectionLabel = styled(Skeleton)`
  ${tw`h-4 w-24 mb-2`}
`;

const CardInput = styled(Skeleton)`
  ${tw`h-12 w-full rounded-md mb-1`}
`;

const CardBrands = styled.div`
  ${tw`flex gap-2 mt-2`}
`;

const CardBrand = styled(Skeleton)`
  ${tw`h-6 w-10 rounded-md`}
`;

const ExpiryAndCVVContainer = styled.div`
  ${tw`flex gap-4 mb-6`}
`;

const ExpirySection = styled.div`
  ${tw`w-1/2`}
`;

const CVVSection = styled.div`
  ${tw`w-1/2`}
`;

const CountrySection = styled.div`
  ${tw`mb-6`}
`;

const ZipSection = styled.div`
  ${tw`mb-6`}
`;

const PayButton = styled(Skeleton)`
  ${tw`h-12 w-full rounded-md`}
`;

const PaymentElementSkeleton: React.FC = () => {
  return (
    <Container>
      <CardNumberSection>
        <SectionLabel />
        <CardInput />
        <CardBrands>
          <CardBrand />
          <CardBrand />
          <CardBrand />
          <CardBrand />
        </CardBrands>
      </CardNumberSection>

      <ExpiryAndCVVContainer>
        <ExpirySection>
          <SectionLabel />
          <CardInput />
        </ExpirySection>
        <CVVSection>
          <SectionLabel />
          <CardInput />
        </CVVSection>
      </ExpiryAndCVVContainer>

      <CountrySection>
        <SectionLabel />
        <CardInput />
      </CountrySection>

      <ZipSection>
        <SectionLabel />
        <CardInput />
      </ZipSection>

      <PayButton />
    </Container>
  );
};

export default PaymentElementSkeleton;
